import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, SimpleChanges } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { Observable, of, Subscription } from "rxjs";
@Component({
  selector: "app-common-logic-row-child",
  templateUrl: "./app-common-logic-row-child.component.html",
  styleUrls: ["./app-common-logic-row-child.component.scss"],
})
export class CommonLogicRowChildComponent implements OnInit, OnDestroy {
  @Input() i: any;
  @Input() control: any;
  @Input() allQuestions: any;
  @Input() currentQuestion: any;
  @Input() postQuesSet: any;
  @Input() postSameSecQuesSet: any;
  @Input() postSecSet: any;
  @Input() includeSecQuesSet: any;
  @Input() parentForm: FormGroup;
  @Input() continuationCheck: any;
  @Output() updateRaterGroup: EventEmitter<boolean> = new EventEmitter();
  preSecSet$: Observable<any>;
  preQuesSet2: any = [];
  @Output()
  addRow: EventEmitter<any> = new EventEmitter();

  @Output()
  removeRow: EventEmitter<any> = new EventEmitter();

  /**
   * Observable for options list.
   */
  quesOptions$: Observable<any>;

  isDefault: boolean = false;

  conditionSetForMCQ: any = [
    { id: "Is Selected", name: "Is Selected" },
    { id: "Is Not Selected", name: "Is Not Selected" },
  ];

  conditionSetForTextbox: any = [
    { id: "Is greater than", name: "Is greater than" },
    { id: "Is greater than or equal to", name: "Is greater than or equal to" },
    { id: "Is less than", name: "Is less than" },
    { id: "Is less than or equal to", name: "Is less than or equal to" },
    { id: "Is equal to", name: "Is equal to" },
    { id: "Is not equal to", name: "Is not equal to" },
    { id: "Is empty", name: "Is empty" },
    { id: "Is not empty", name: "Is not empty" },
    { id: "Contains", name: "Contains" },
    { id: "Does not contain", name: "Does not contain" },
  ];

  interConditionSet: any = [
    { id: "AND", name: "And" },
    { id: "OR", name: "Or" },
  ];

  comparisionsGroup:any = [
    { id: 1, name: "Respondent’s input" },
    { id: 2, name: "Another Q's response" }
  ];

  showOperatorValue: boolean = true;
  showConditionSetForMCQ: boolean = false;
  querstionOrRaterGroup: any[] = [];
  subscription: any;
  TextBoxConditionInputFieldType: string = 'number';
  comparisionType: boolean = false;

  constructor() {}

  ngOnInit() {
    this.editCondition();
    if (this.currentQuestion._type == 1) {
      this.selectedQuesIsMCQ = true;
      this.quesOptions$ = of(this.currentQuestion["question_options"]);
    } else {
      this.selectedQuesIsTextbox = true;
    }

    if (
      this.control.get("operator")?.value == "Is empty" ||
      this.control.get("operator")?.value == "Is not empty"
    ) {
      this.control.get("operator_value")?.setValidators([]);
      this.control.get("question_source")?.setValidators([]);
      this.showOperatorValue = false;
    }else{
      if(this.currentQuestion._type===2){
        this.control.get("operator_value")?.setValidators([Validators.nullValidator]);
        this.control.get("question_source")?.setValidators([Validators.nullValidator]);
      }
      
    }
    this.control.get("operator_value")?.updateValueAndValidity();

    this.subscription = this.control.get("operator")?.valueChanges.subscribe((data)=>{
      if (
        data == "Is empty" ||
        data == "Is not empty"
      ) {
        this.control.get("operator_value")?.setValidators([Validators.nullValidator]);
        this.showOperatorValue = false;
        this.control.get("operator_value")?.updateValueAndValidity();
      }else{
        if(this.currentQuestion._type===2){
          this.control.get("operator_value")?.setValidators([Validators.required]);
          this.control.get("operator_value")?.updateValueAndValidity();
        }
        
      }
    })
    let secId = this.control.get("section_destination").value;
    let questions: any = [];
    this.allQuestions.forEach(section => {
        if (section.questions) {
            questions.push(...section.questions);
        }
    });
    this.onSectionSelectionForDisplay(questions);
    if(this.control?.get('condition_type')?.value === 2){
      this.comparisionType = true;
      this.control.get("operator_value")?.disable();
      this.control.get("question_source")?.setValidators([Validators.required]);
    }
    else{
      if(this.control?.get('condition_type')?.value === 1 && !this.selectedQuesIsMCQ){
        this.control.get("operator_value")?.setValidators([Validators.required]);
        this.control.get("operator_value")?.updateValueAndValidity();
      }
      this.comparisionType = false;
    }

    if(this.currentQuestion._type == 8 && this.parentForm?.get('group_type')?.value == 'rater-group'){
      this.parentForm?.get("user_type")?.value ? this.parentForm?.get("user_type")?.value:this.parentForm?.get("user_type")?.setValue("participants");
      this.control.get('operator').setValidators([Validators.nullValidator]);
      this.control.get("operator_value")?.setValidators([Validators.nullValidator]);
      this.control.get("operator_value")?.updateValueAndValidity();
      this.control.get("logic_type_name")?.setValue("display");
      this.control.get("logic_type_name")?.disable();      
    }
    if(this.currentQuestion._type!==2){
      this.control.removeControl('condition_type');
    }
    this.initializeQuestionOrRaterGroup();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['continuationCheck'] && !changes['continuationCheck'].firstChange) {
      this.control.get('prevent_continuation')?.setValue(this.continuationCheck);
    }
  }


  onSectionSelectionForDisplay(allQuestions: any) {
    this.preSecSet$ = of([]);
    this.preQuesSet2 = [];
    const currentQuestionId = this.currentQuestion.id;
    let isBeforeCurrentQuestion = true;

    allQuestions.forEach((question: any) => {
      if (question.obj_type === "pagebrake") return;

      if (question.id === currentQuestionId) {
        isBeforeCurrentQuestion = false;
      } else if (isBeforeCurrentQuestion && question["_type"] === 2) {
        question["name"] = question["_type"] === 8
          ? this.extractContent(question.text)
          : `Q${question.numbering} ${this.extractContent(question.text)}`;

        const questionUrlParts = question.url.split("/");
        question["_id"] = +questionUrlParts[questionUrlParts.length - 2];
        this.preQuesSet2.push(question);
      }
    });

    this.preSecSet$ = of(this.preQuesSet2);
  }

  extractContent(s: any) {
    var span = document.createElement("span");
    span.innerHTML = s;
    return span.textContent || span.innerText;
  }

  getArrayControl() {
    return (<FormArray>this.parentForm.controls["conditions"]).controls;
  }

  selectedQuesIsMCQ: boolean = false;
  selectedQuesIsTextbox: boolean = false;

  // user changes choosen question -> show the options dropdown accordingly
  onQuestionChange(i: any) {
    this.selectedQuesIsMCQ = false;
    this.selectedQuesIsTextbox = false;
    const control = <FormArray>this.parentForm.controls["logic"];
    const ithControl = control.controls[i];
    // let quesId = this.parentForm.value["logic"][i]
    //   .question_id_from_locator;
    // let ques = this.postQuesSet.filter((elem: any) => {
    //   if (elem._id == quesId) {
    //     return true;
    //   }
    // });

    // let t = ques[0]._type;
    // if mcq
    // if (t == 1) {
    //   ithControl.get("question_type").patchValue(t);
    //   this.quesOptions$ = this.getQuesOptions(i);
    //   this.selectedQuesIsMCQ = true;
    // }
    // if text box
    // else if (t == 2) {
    //   ithControl.get("question_type").patchValue(t);
    //   ithControl.get("question_choice_locator").patchValue(null);
    //   this.selectedQuesIsTextbox = true;
    // }
  }

  getQuesOptions(i: any) {
    let quesId = this.parentForm.value["conditions"][i]
      .question_id_from_locator;
    if (quesId) {
      let ques = this.postQuesSet.filter((elem: any) => {
        if (elem._id == quesId) {
          return true;
        }
      });
      return of(ques[0]["question_options"]);
    } else of([]);
  }

  addRowEvent() {
    this.addRow.next(true);
  }

  removeRowEvent() {
    this.removeRow.next(this.i);
  }

  clear() {
    this.control.get("question_choice_locator")?.patchValue(null);
    this.control.get("operator")?.patchValue(null);
    this.control.get("operator_value")?.patchValue(null);
  }

  editCondition() {
    if (
      this.currentQuestion.logic &&
      this.currentQuestion.logic.length &&
      this.parentForm.value["logic_type"]
    ) {
      // this.onQuestionChange(this.i);
      if (this.currentQuestion._type == 1) {  
        this.showConditionSetForMCQ = true;
        let flag = false;
        let currentQuesChoiceLocator = this.control.get("question_choice_locator")?.value;
        if(currentQuesChoiceLocator){
          let currentQuesOptions = this.currentQuestion["question_options"];
          if(currentQuesOptions && currentQuesOptions.length){
            currentQuesOptions.forEach((op:any) => {
              if(op.id == currentQuesChoiceLocator){
                flag = true;
              }
            });
          }
        }
        if(!flag){
          this.control.get("question_choice_locator")?.patchValue(null);
        }
      } else {
        // this.selectedQuesIsTextbox = true;
      }
    }
  }

  onTextboxConditionChange(item: any) {
    if (!item) return;
    const numberConditions = [
        "Is greater than",
        "Is greater than or equal to",
        "Is less than",
        "Is less than or equal to"
    ];

    this.TextBoxConditionInputFieldType = numberConditions.includes(item.id) ? "number" : "text";
    this.showOperatorValue = !(item.id === "Is empty" || item.id === "Is not empty");
    if(!this.showOperatorValue){
      this.control.get("operator_value")?.setValue(null);
      this.control.get("question_source")?.setValue(null);
      this.control.get("operator_value")?.disable();
      this.control.get("question_source")?.disable();
      this.control.get("condition_type")?.patchValue(null);
      this.control.get("condition_type")?.setValidators([Validators.nullValidator]);
      this.control.get("condition_type")?.updateValueAndValidity();
      this.control.get("operator_value")?.setValidators([]);
      this.control.get("question_source")?.setValidators([]);
    }
    else{
      this.control.get("operator_value")?.enable();
      this.control.get("question_source")?.enable();
      this.control.get("condition_type")?.patchValue(this.control?.get('condition_type')?.value);
      this.control.get("condition_type")?.setValidators([Validators.required]);
      if(this.control?.get('condition_type')?.value === 1){
        this.comparisionType = false;
        this.control.get("operator_value")?.enable();
        this.control.get("question_source")?.disable();
        this.control.get("operator_value")?.setValidators([Validators.required]);
        this.control.get("question_source")?.patchValue(null);
      }
      else if(this.control?.get('condition_type')?.value === 2){
        this.comparisionType = true;
        this.control.get("question_source")?.enable();
        this.control.get('question_source')?.setValidators([Validators.required]);
        this.control.get("operator_value")?.patchValue(null);
        this.control.get("operator_value")?.disable();
      }
      else{
        this.control.get("condition_type")?.patchValue(null);
        this.control.get("operator_value")?.enable();
        this.control.get("question_source")?.disable();
        this.control.get("operator_value")?.setValidators([Validators.required]);
        this.control.get("question_source")?.setValidators([Validators.nullValidator]);
        this.control.get("operator_value")?.updateValueAndValidity();
        this.control.get("question_source")?.updateValueAndValidity();
        this.comparisionType = false;
      }
    }
  }
  

  onComparisonSelect(item: any){
    this.control?.get('condition_type')?.setValue(item.id);
    this.control?.get('condition_type')?.updateValueAndValidity();
    if(item.id === 1){
      this.comparisionType = false;
      this.control.get("operator_value")?.enable();
      this.control.get("question_source")?.disable();
      this.control.get("operator_value")?.setValidators([Validators.required]);
      this.control.get("question_source")?.patchValue(null);
    }
    else{
      this.comparisionType = true;
      this.control.get("question_source")?.enable();
      this.control.get('question_source')?.setValidators([Validators.required]);
      this.control.get("operator_value")?.patchValue(null);
      this.control.get("operator_value")?.disable();
    }
}


  onMcqResponseOptionSelection(event: any) {
    this.showConditionSetForMCQ = true;
  }
  initializeQuestionOrRaterGroup(){
    if(this.parentForm?.get('group_type')?.value == 'rater-group'){
      this.control.get('operator').setValidators([Validators.nullValidator]);
      this.control.get("logic_type_name")?.disable();
      this.updateRaterGroup.emit(this.isRaterGroup);
    }
    let defaultOptions = [
      { id: "question", name: "Question" },
      { id: "rater-group", name: "Rater Group" }
    ];
    // Remove "question" if _type === 8 //i.e currentQuestion is descriptive type
    this.querstionOrRaterGroup = this.currentQuestion._type === 8
      ? defaultOptions.filter(item => item.id !== "question")
      : defaultOptions;
  }

  updateQuestionOrRaterGroup() {
    let questionOrRaterGroup = [
      { id: "question", name: "Question" },
      { id: "rater-group", name: "Rater Group" }
    ];
  
    if (this.currentQuestion._type === 8) {
      questionOrRaterGroup = questionOrRaterGroup.filter(item => item.id !== "question");
    }
  
    return questionOrRaterGroup;
  }

  onQuestionOrRaterGroupSelect(e){
    if(e.id == "rater-group"){
      this.parentForm?.get("user_type")?.setValue("participants")
      this.control.get('question_choice_locator').setValue(null);
      // this.control.get('operator').setValue(null);
      this.control.get("logic_type_name")?.setValue("display")
      this.control.get("logic_type_name")?.disable();
      this.control.get('operator').setValidators([Validators.nullValidator])
      this.control.get("operator_value")?.setValidators([Validators.nullValidator]);
      this.control.get("operator_value")?.updateValueAndValidity();
      //
      /**
       * control question_choice_locator
       * control operator
       */
    }else{
      this.parentForm?.get("user_type")?.setValue(null);
      this.control.get("logic_type_name")?.setValue(null)
      this.control.get("logic_type_name")?.enable()
    }
  }

  raterGroupList = [
    {
      id:"participants",
      name:"Participants",
    },
    {
      id:"non-participants",
      name:"Non-Participants"
    }
  ]
  onRaterGroupSelect(e){
    
  }


  get isRaterGroup(){
    this.updateRaterGroup.emit(this.parentForm && this.parentForm?.get('group_type')?.value == 'rater-group');
    return this.parentForm && this.parentForm?.get('group_type')?.value == 'rater-group'
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }
}
